import { camelCase, mapKeys } from 'lodash'

import { CallConfig, GroupCallInfo, ParticipantInfo } from 'types/call'

function camelizeKeys<In extends Object>(object: In) {
  return mapKeys(object, (_v: unknown, k: string) => camelCase(k))
}

function parseConfig(configContainerId) {
  const container = document.getElementById(configContainerId)

  const callConfig = camelizeKeys(JSON.parse(container.getAttribute('data-config'))) as CallConfig
  const callInfo = camelizeKeys(JSON.parse(container.getAttribute('data-call'))) as GroupCallInfo
  const iceServers = JSON.parse(container.getAttribute('data-ice-servers')) as RTCIceServer[]
  const featureFlags = JSON.parse(container.getAttribute('data-feature-flags')) as Record<
    string,
    boolean
  >
  const language = container.getAttribute('data-locale') || 'de'
  const participantInfo = JSON.parse(
    container.getAttribute('data-participant-info'),
  ) as ParticipantInfo

  return {
    callConfig,
    callInfo,
    iceServers,
    featureFlags,
    language,
    participantInfo,
  }
}

export default parseConfig
